import React from 'react';
import Svg, {Rect} from 'react-native-svg';

const SQUARES: [number, number][] = [
  [0, 0],
  [32, 0],
  [64, 0],
  [16, 16],
  [48, 16],
  [0, 32],
  [32, 32],
  [64, 32],
  [16, 48],
  [48, 48],
  [0, 64],
  [32, 64],
  [64, 64],
];

type CheckerboardSVGProps = {
  size?: number;
  color?: string;
  squareSize?: number;
};

const CheckerboardSVG: React.FC<CheckerboardSVGProps> = ({
  size = 120,
  color = '#FACF47',
  squareSize = 16,
}) => (
  <Svg width={size} height={size} viewBox="0 0 80 80">
    {SQUARES.map(([x, y], i) => (
      <Rect
        key={i}
        x={x}
        y={y}
        width={squareSize}
        height={squareSize}
        fill={color}
      />
    ))}
  </Svg>
);

export default CheckerboardSVG;
